import React, { useEffect, useState } from 'react';
import api from '../lib/api';
import { getAssetIdentity } from '../utils/assetIdentity';
import { formatInCST } from '../utils/timezone';
import { Button } from './ui/button';

export default function AssetIdentityHeader({ asset, networkInterfaces = [] }) {
  const [result, setResult] = useState(null);
  const [revision, setRevision] = useState(0);
  useEffect(() => {
    let cancelled = false;
    setResult(null);
    if (!asset?.ninjarmm_device_id) return;
    const id = asset.ninjarmm_device_id;
    Promise.allSettled([
      api.get('/ninjarmm/device/' + id),
      api.get('/ninjarmm/device/' + id + '/network-interfaces')
    ]).then(([details, network]) => {
      if (cancelled) return;
      const reported = details.status === 'fulfilled' ? details.value.data : null;
      const device = String(reported?.id) === String(id) ? reported : null;
      const raw = network.status === 'fulfilled' ? network.value.data : null;
      const interfaces = Array.isArray(raw?.interfaces) ? raw.interfaces : Array.isArray(raw) ? raw : null;
      setResult({assetId:asset.id, deviceId:String(id), device:device?.id ? device : null, interfaces,
        partial:!device?.id || !interfaces});
    });
    return () => {cancelled = true;};
  }, [asset?.id, asset?.ninjarmm_device_id, revision]);
  const current = result?.assetId === asset?.id && result?.deviceId === String(asset?.ninjarmm_device_id) ? result : null;
  const identity = getAssetIdentity(asset, current?.device || {}, current?.interfaces || networkInterfaces);
  const fields = [['Public IP',identity.publicIp],['Private IP',identity.privateIp],['MAC address',identity.mac],['Serial / Service tag',identity.serial]];
  if (identity.assetTag) fields.push(['Asset tag',identity.assetTag]);
  const lastContact = current?.device?.lastContact;
  const contactDate = typeof lastContact === 'number' ? new Date(lastContact * 1000) : lastContact;
  const validContact = contactDate && !Number.isNaN(new Date(contactDate).getTime());
  return <section aria-label="Asset identification" className="asset-identity" data-testid="asset-identity-header">
    <div className="flex flex-wrap items-center justify-between gap-2 mb-3">
      <p className="text-sm font-medium break-words">{identity.model || 'Device identification'}</p>
      {asset?.ninjarmm_device_id && <Button type="button" size="sm" variant="ghost" disabled={!current} onClick={() => setRevision(v => v + 1)}>Refresh identifiers</Button>}
    </div>
    <dl className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-3">
      {fields.map(([label,value]) => <div key={label} className="min-w-0">
        <dt className="text-xs text-muted-foreground mb-1">{label}</dt>
        <dd className="font-mono text-sm select-text break-words" title={label === 'Private IP' ? identity.interfaceName : undefined}>{value || 'Not reported'}</dd>
      </div>)}
    </dl>
    <p className="text-xs text-muted-foreground mt-3" role="status">
      {!asset?.ninjarmm_device_id ? 'Saved asset details · NinjaOne device not linked' : !current ? 'Checking NinjaOne identifiers…' : current.partial ? 'NinjaOne response incomplete · showing available identifiers' : 'Reported by NinjaOne'}
      {validContact && ' · Last device contact: ' + formatInCST(contactDate, 'MMM d, yyyy h:mm a')}
    </p>
  </section>;
}
